import { isMasked } from 'utils/validation';
import utils from '@ehi/global-marketing-interface/lib/utils';

/**
 * Create and return a function to be used by the GMI UI commit action. This will determine which
 * payload from alamo overrides the data from GMI.
 *
 * @private
 * IMPORTANT
 * Note that {gmiPayload} will be passed to this function, and we need to cherry-pick any data
 * that we wish to maintain coming from GMI
 */
export const mergePayload = (gmiPayload, data) => {
  const { is_auto_comms_consent_implied, phone, isTrueModify, phoneCountryCode, payAtCounter } = data;
  const { driver_info } = gmiPayload;
  const driverInfo = { ...driver_info };

  if (driver_info && isMasked(phone)) {
    delete driver_info.phone;
  }

  if (driver_info?.phone?.country_code || (!driver_info?.phone?.country_code && !isTrueModify && phoneCountryCode)) {
    // updating phone country code, if missing for deeplinks
    if (!driverInfo.phone?.country_code && phoneCountryCode) {
      driver_info.phone = {
        ...driver_info.phone,
        country_code: phoneCountryCode,
      };
    }
  }

  // deleting the props that are not required for res commit call
  delete data.isTrueModify;
  delete data.phoneCountryCode;

  // deleting the payment method from the reviewCommit payload, only on trueModify flow
  // if selected payAtCounter billing type option and  payment_method contains empty string
  // if we are passing empty string payment_method,we were getting GBO response with bas json format
  // implemeneted the way national is doing for true modify flow and billing type is payatcoutner.
  if (
    isTrueModify &&
    payAtCounter &&
    Object.hasOwn(gmiPayload, 'payment_method') &&
    gmiPayload?.payment_method === ''
  ) {
    delete gmiPayload.payment_method;
  }

  // returning the data payload necessary to combine alamoWeb and gmi hydrated data
  const newPayload = {
    ...gmiPayload,
    ...(driver_info && { driver_info: driverInfo }),
    ...(utils.types(is_auto_comms_consent_implied).isDefined && {
      is_auto_comms_consent_implied,
    }),
  };

  return {
    payload: newPayload,
  };
};
